var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zong"},[_c('div',{staticClass:"echart_container",attrs:{"id":_vm.groupId}})])}
var staticRenderFns = []

export { render, staticRenderFns }